import ThemeButton from "../theme-button/ThemeButton";
import styles from "./primary-button.module.scss";

export const PrimaryButton = ({ className, disabled, ...restProps }) => {
  return (
    <ThemeButton
      {...restProps}
      disabled={disabled}
      className={`${disabled ? "" : styles.primaryButton} ${className}`}
    />
  );
};

export default PrimaryButton;
